import StarIcon from '@Components/Icons/StarIcon';

const StarLabel = (props: { text: string }) => {
    return (
        <div className='flex flex-row items-center w-fit rounded px-1 py-0.5 bg-peppermint-500'>
            <StarIcon />
            <span className='font-sora-bold text-xs pl-1 leading-120%'>
                {props.text}
            </span>
        </div>
    );
};

export default StarLabel;
